<template>
  <layout-admin-dashboard-view :show-toolbar="false">
    <template #title>
      {{ translateTitleCase("entity.crud.createEntityTitle") }}
      <strong>{{ t(`entity.${entityType}.name`) }}</strong>
    </template>

    <template #default>
      <crud-create
        :form-path="'entity/' + entityType + '/create'"
        :form-action="'entity/' + entityType"
        :success-redirect="computedSuccessRedirect"
        :entity-type="entityType">
      </crud-create>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import CrudCreate from "@/client/components/crud/Create.vue";

export default {
  name: "EntityCreate",
  components: { CrudCreate },
  props: {
    entityType: {
      type: String,
      default: "default",
    },
    successRedirect: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data: function () {
    return {
      entity: {},
    };
  },
  computed: {
    formPath() {
      return "entity/" + this.entityType + "/create";
    },
    formAction() {
      return "entity/" + this.entityType;
    },
    computedSuccessRedirect() {
      if (this.successRedirect) {
        return this.successRedirect;
      }

      // 1. Check the Vuex store for the last known route
      const lastLocalRoute = this.sg("route.lastRoute");
      if (lastLocalRoute) {
        return { ...lastLocalRoute };
      } else {
        return {
          name: "admin-entity-entityType",
          params: { entityType: this.entityType },
        };
      }
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
